import { render } from "./StageDoForward.vue?vue&type=template&id=db989568&scoped=true"
import script from "./StageDoForward.vue?vue&type=script&lang=js"
export * from "./StageDoForward.vue?vue&type=script&lang=js"

import "./StageDoForward.vue?vue&type=style&index=0&id=db989568&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db989568"]])

export default __exports__